let _profUserId = 'default'; try { require('@react-native-async-storage/async-storage').default.getItem('userToken').then(function(t){if(t)_profUserId=t.slice(0,16);}).catch(function(){}); } catch(e) {}
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  Alert,
  Modal,
  ActivityIndicator,
  Dimensions,
  TextInput,
  Image,
  Animated,
  RefreshControl,
  FlatList,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Ionicons, MaterialCommunityIcons, FontAwesome5 } from '@expo/vector-icons';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { apiFetch } from '../../utils/apiClient';
import useProfile from '../../hooks/useProfile';
import ProfileManagementService from '../../services/ProfileManagementService';
import PROFILE_KEYS from '../../constants/profileKeys';

// === API CONFIG ===
const API_BASE = 'https://api.jobeng.ai';
const API_KEY = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
const { width, height } = Dimensions.get('window');

// Business Portal Integration Service
const BusinessPortalIntegration = {
  // Business Portal API endpoints
  endpoints: {
    tests: '/api/business/tests',
    results: '/api/business/test-results',
    analytics: '/api/business/analytics',
    candidates: '/api/business/candidates',
    assignments: '/api/business/test-assignments',
  },

  // Sync with business portal tests
  async syncBusinessTests() {
    try {
      // Simulate API call to business portal
      const businessTests = await this.getBusinessTests();
      await AsyncStorage.setItem(`professional_${_profUserId}_business_tests`, JSON.stringify(businessTests));
      return businessTests;
    } catch (error) {
      console.error('Error syncing business tests:', error);
      return [];
    }
  },

  // Get tests from business portal
  async getBusinessTests() {
    // Mock business portal tests data
    return [
      {
        id: 'biz_test_1',
        name: 'Senior Software Engineer Assessment',
        category: 'Technical',
        type: 'Coding Challenge',
        difficulty: 'Advanced',
        duration: 120,
        questions: 8,
        passingScore: 80,
        status: 'active',
        createdBy: 'Business Admin',
        businessId: 'business_123',
        assignedCandidates: 15,
        completedAttempts: 12,
        averageScore: 78.5,
        skills: ['JavaScript', 'React', 'Node.js', 'System Design'],
        sections: [
          { name: 'Algorithm Challenges', questions: 3, timeLimit: 45, weight: 40 },
          { name: 'System Design', questions: 2, timeLimit: 30, weight: 35 },
          { name: 'Code Review', questions: 3, timeLimit: 45, weight: 25 },
        ],
        businessControlled: true,
        allowProfessionalAccess: true,
      },
      {
        id: 'biz_test_2',
        name: 'Project Management Assessment',
        category: 'Professional',
        type: 'Multiple Choice',
        difficulty: 'Intermediate',
        duration: 75,
        questions: 30,
        passingScore: 70,
        status: 'active',
        createdBy: 'Business Admin',
        businessId: 'business_123',
        assignedCandidates: 22,
        completedAttempts: 18,
        averageScore: 74.2,
        skills: ['Project Planning', 'Risk Management', 'Team Leadership', 'Agile'],
        sections: [
          { name: 'Project Planning', questions: 10, timeLimit: 25, weight: 35 },
          { name: 'Risk Management', questions: 8, timeLimit: 20, weight: 25 },
          { name: 'Team Leadership', questions: 7, timeLimit: 15, weight: 20 },
          { name: 'Agile Methodologies', questions: 5, timeLimit: 15, weight: 20 },
        ],
        businessControlled: true,
        allowProfessionalAccess: true,
      },
      {
        id: 'biz_test_3',
        name: 'Data Analysis Practical',
        category: 'Technical',
        type: 'Practical Exercise',
        difficulty: 'Advanced',
        duration: 90,
        questions: 12,
        passingScore: 75,
        status: 'active',
        createdBy: 'Business Admin',
        businessId: 'business_123',
        assignedCandidates: 8,
        completedAttempts: 6,
        averageScore: 81.3,
        skills: ['Python', 'SQL', 'Data Visualization', 'Statistics'],
        sections: [
          { name: 'Data Cleaning', questions: 3, timeLimit: 25, weight: 25 },
          { name: 'Statistical Analysis', questions: 4, timeLimit: 35, weight: 35 },
          { name: 'Visualization', questions: 3, timeLimit: 20, weight: 25 },
          { name: 'Insights', questions: 2, timeLimit: 10, weight: 15 },
        ],
        businessControlled: true,
        allowProfessionalAccess: true,
      },
      {
        id: 'biz_test_4',
        name: 'Leadership Assessment',
        category: 'Soft Skills',
        type: 'Situational Judgment',
        difficulty: 'Intermediate',
        duration: 50,
        questions: 20,
        passingScore: 70,
        status: 'active',
        createdBy: 'Business Admin',
        businessId: 'business_123',
        assignedCandidates: 12,
        completedAttempts: 10,
        averageScore: 76.8,
        skills: ['Leadership', 'Decision Making', 'Team Management', 'Communication'],
        sections: [
          { name: 'Team Leadership', questions: 6, timeLimit: 15, weight: 30 },
          { name: 'Decision Making', questions: 5, timeLimit: 12, weight: 25 },
          { name: 'Conflict Resolution', questions: 5, timeLimit: 12, weight: 25 },
          { name: 'Strategic Planning', questions: 4, timeLimit: 11, weight: 20 },
        ],
        businessControlled: true,
        allowProfessionalAccess: true,
      },
    ];
  },

  // Get test results for business portal
  async getTestResults(testId = null, candidateId = null) {
    const mockResults = [
      {
        id: 'result_1',
        testId: 'biz_test_1',
        testName: 'Senior Software Engineer Assessment',
        candidateId: 'candidate_1',
        candidateName: 'John Smith',
        candidateEmail: 'john.smith@email.com',
        score: 85,
        passed: true,
        completedAt: '2025-01-12T09:30:00Z',
        timeSpent: 105,
        sectionScores: [
          { section: 'Algorithm Challenges', score: 88, timeSpent: 42 },
          { section: 'System Design', score: 82, timeSpent: 28 },
          { section: 'Code Review', score: 85, timeSpent: 35 },
        ],
        businessId: 'business_123',
        feedback: 'Strong performance in algorithms and code review. System design could be improved.',
        recommendations: ['Focus on scalability concepts', 'Practice distributed systems design'],
      },
      {
        id: 'result_2',
        testId: 'biz_test_2',
        testName: 'Project Management Assessment',
        candidateId: 'candidate_2',
        candidateName: 'Sarah Johnson',
        candidateEmail: 'sarah.johnson@email.com',
        score: 78,
        passed: true,
        completedAt: '2025-01-11T14:20:00Z',
        timeSpent: 68,
        sectionScores: [
          { section: 'Project Planning', score: 82, timeSpent: 22 },
          { section: 'Risk Management', score: 75, timeSpent: 18 },
          { section: 'Team Leadership', score: 80, timeSpent: 14 },
          { section: 'Agile Methodologies', score: 76, timeSpent: 14 },
        ],
        businessId: 'business_123',
        feedback: 'Good overall project management knowledge. Strong in planning and leadership.',
        recommendations: ['Enhance risk management skills', 'Deepen Agile methodology understanding'],
      },
      {
        id: 'result_3',
        testId: 'biz_test_3',
        testName: 'Data Analysis Practical',
        candidateId: 'candidate_3',
        candidateName: 'Michael Chen',
        candidateEmail: 'michael.chen@email.com',
        score: 92,
        passed: true,
        completedAt: '2025-01-10T16:45:00Z',
        timeSpent: 82,
        sectionScores: [
          { section: 'Data Cleaning', score: 95, timeSpent: 20 },
          { section: 'Statistical Analysis', score: 90, timeSpent: 32 },
          { section: 'Visualization', score: 88, timeSpent: 18 },
          { section: 'Insights', score: 94, timeSpent: 12 },
        ],
        businessId: 'business_123',
        feedback: 'Excellent data analysis skills across all areas. Strong candidate.',
        recommendations: ['Consider for senior data analyst role', 'Explore machine learning applications'],
      },
    ];

    if (testId) {
      return mockResults.filter(result => result.testId === testId);
    }
    if (candidateId) {
      return mockResults.filter(result => result.candidateId === candidateId);
    }
    return mockResults;
  },

  // Submit test result to business portal
  async submitTestResult(resultData) {
    try {
      // Simulate API call to business portal
      console.log('Submitting test result to business portal:', resultData);
      
      // Store locally for offline capability
      const existingResults = await AsyncStorage.getItem(`professional_${_profUserId}_test_results`) || '[]';
      const results = JSON.parse(existingResults);
      results.push({
        ...resultData,
        id: `result_${Date.now()}`,
        submittedAt: new Date().toISOString(),
        businessId: 'business_123',
      });
      await AsyncStorage.setItem(`professional_${_profUserId}_test_results`, JSON.stringify(results));
      
      // Notify business portal of new result
      this.notifyBusinessPortal('test_completed', resultData);
      
      return { success: true, id: `result_${Date.now()}` };
    } catch (error) {
      console.error('Error submitting test result:', error);
      return { success: false, error: error.message };
    }
  },

  // Notify business portal of events
  notifyBusinessPortal(event, data) {
    console.log(`Business Portal Notification - ${event}:`, data);
    // In real implementation, this would send webhook or real-time notification
  },

  // Get analytics for business portal
  async getAnalytics(timeRange = '30d') {
    return {
      totalTests: 4,
      totalCandidates: 57,
      totalAttempts: 46,
      averageScore: 77.7,
      passRate: 82.6,
      completionRate: 89.1,
      topPerformingTest: 'Data Analysis Practical',
      mostPopularTest: 'Senior Software Engineer Assessment',
      timeRange,
      trends: {
        testsCreated: [2, 1, 0, 1, 0, 0, 0], // Last 7 days
        candidatesAssessed: [8, 6, 4, 7, 5, 9, 7], // Last 7 days
        averageScores: [75, 78, 76, 79, 77, 80, 78], // Last 7 days
      },
      categoryBreakdown: {
        'Technical': 65,
        'Professional': 20,
        'Soft Skills': 15,
      },
      difficultyDistribution: {
        'Beginner': 10,
        'Intermediate': 45,
        'Advanced': 45,
      },
    };
  },
};

function TestsInterviewsScreen({ navigation }) {
  // ── Profile integration (auto-injected) ──
  const profileCtx = useProfile();
  // State Management
  const [activeTab, setActiveTab] = useState('overview');
  const [isLoading, setIsLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [assessmentModal, setAssessmentModal] = useState(false);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [assessmentStarted, setAssessmentStarted] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [assessmentScore, setAssessmentScore] = useState(0);
  const [fadeAnim] = useState(new Animated.Value(0));
  const timerRef = useRef(null);
  
  // Business Integration State
  const [businessTests, setBusinessTests] = useState([]);
  const [testResults, setTestResults] = useState([]);
  const [businessAnalytics, setBusinessAnalytics] = useState({});
  const [syncStatus, setSyncStatus] = useState({ syncing: false, lastSync: null });
  const [businessConnection, setBusinessConnection] = useState({ connected: true, businessId: 'business_123' });

  // Professional Assessment Data (existing tests available to professionals)
  const professionalAssessments = [
    {
      id: 'technical',
      title: 'Technical Assessment',
      description: 'Test your technical knowledge and problem-solving skills',
      duration: 45,
      questions: 12,
      difficulty: 'Intermediate',
      icon: 'code-slash',
      color: '#0e4e96',
      passingScore: 70,
      type: 'professional_managed',
      businessControlled: false,
    },
    {
      id: 'psychometric',
      title: 'Psychometric Test',
      description: 'Evaluate personality traits and cognitive abilities',
      duration: 30,
      questions: 25,
      difficulty: 'Beginner',
      color: '#8b5cf6',
      icon: 'analytics',
      passingScore: 65,
      type: 'professional_managed',
      businessControlled: false,
    },
    {
      id: 'aptitude',
      title: 'Aptitude Test',
      description: 'Logical reasoning and numerical analysis',
      duration: 35,
      questions: 15,
      difficulty: 'Intermediate',
      icon: 'calculator',
      color: '#f59e0b',
      passingScore: 70,
      type: 'professional_managed',
      businessControlled: false,
    },
    {
      id: 'situational',
      title: 'Situational Judgment',
      description: 'Workplace scenarios and decision making',
      duration: 25,
      questions: 10,
      difficulty: 'Beginner',
      icon: 'people',
      color: '#ec4899',
      passingScore: 65,
      type: 'professional_managed',
      businessControlled: false,
    },
  ];

  // Combined assessments (business + professional)
  const [allAssessments, setAllAssessments] = useState([]);

  useEffect(() => {
    initializeScreen();
    syncWithBusinessPortal();
  }, []);

  const initializeScreen = async () => {
    setIsLoading(true);
    try {
      await loadBusinessTests();
      await loadTestResults();
      await loadAnalytics();
      combineAssessments();
    } catch (error) {
      console.error('Error initializing screen:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const syncWithBusinessPortal = async () => {
    setSyncStatus({ syncing: true, lastSync: null });
    try {
      const tests = await BusinessPortalIntegration.syncBusinessTests();
      setBusinessTests(tests);
      setSyncStatus({ syncing: false, lastSync: new Date().toISOString() });
    } catch (error) {
      console.error('Error syncing with business portal:', error);
      setSyncStatus({ syncing: false, lastSync: null });
    }
  };

  const loadBusinessTests = async () => {
    try {
      const tests = await BusinessPortalIntegration.getBusinessTests();
      setBusinessTests(tests);
    } catch (error) {
      console.error('Error loading business tests:', error);
    }
  };

  const loadTestResults = async () => {
    try {
      const results = await BusinessPortalIntegration.getTestResults();
      setTestResults(results);
    } catch (error) {
      console.error('Error loading test results:', error);
    }
  };

  const loadAnalytics = async () => {
    try {
      const analytics = await BusinessPortalIntegration.getAnalytics();
      setBusinessAnalytics(analytics);
    } catch (error) {
      console.error('Error loading analytics:', error);
    }
  };

  const combineAssessments = () => {
    const combined = [
      ...businessTests.map(test => ({
        ...test,
        id: test.id,
        title: test.name,
        description: test.description || `${test.category} assessment created by business`,
        icon: getIconForCategory(test.category),
        color: getColorForCategory(test.category),
        type: 'business_managed',
        businessControlled: true,
      })),
      ...professionalAssessments,
    ];
    setAllAssessments(combined);
  };

  const getIconForCategory = (category) => {
    switch (category) {
      case 'Technical': return 'code-slash';
      case 'Professional': return 'briefcase';
      case 'Soft Skills': return 'people';
      case 'Creative': return 'color-palette';
      default: return 'document-text';
    }
  };

  const getColorForCategory = (category) => {
    switch (category) {
      case 'Technical': return '#3B82F6';
      case 'Professional': return '#8B5CF6';
      case 'Soft Skills': return '#EC4899';
      case 'Creative': return '#F59E0B';
      default: return '#6B7280';
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await syncWithBusinessPortal();
    await loadTestResults();
    await loadAnalytics();
    combineAssessments();
    setRefreshing(false);
  };

  const startAssessment = (assessment) => {
    if (assessment.businessControlled) {
      // Check if user has access to business-controlled test
      Alert.alert(
        'Business Assessment',
        'This assessment is managed by the business. You can only take it if assigned by the business.',
        [
          { text: 'OK', style: 'default' },
          { 
            text: 'Request Access', 
            onPress: () => requestBusinessTestAccess(assessment),
            style: 'default'
          },
        ]
      );
      return;
    }

    setSelectedAssessment(assessment);
    setCurrentQuestion(0);
    setAnswers({});
    setTimeRemaining(assessment.duration * 60);
    setAssessmentStarted(false);
    setShowResults(false);
    setAssessmentModal(true);
  };

  const requestBusinessTestAccess = (assessment) => {
    Alert.alert(
      'Access Requested',
      `Your request to access "${assessment.title}" has been sent to the business. You will be notified when access is granted.`,
      [{ text: 'OK' }]
    );
    
    // In real implementation, this would send a request to the business portal
    BusinessPortalIntegration.notifyBusinessPortal('access_requested', {
      testId: assessment.id,
      testName: assessment.title,
      candidateId: 'current_user_id',
      requestedAt: new Date().toISOString(),
    });
  };

  const submitAssessmentResult = async (score, answers) => {
    const resultData = {
      testId: selectedAssessment.id,
      testName: selectedAssessment.title,
      candidateId: 'current_user_id', // In real app, get from auth
      candidateName: 'Current User', // In real app, get from profile
      candidateEmail: 'user@email.com', // In real app, get from profile
      score: score,
      passed: score >= selectedAssessment.passingScore,
      completedAt: new Date().toISOString(),
      timeSpent: (selectedAssessment.duration * 60) - timeRemaining,
      answers: answers,
      businessControlled: selectedAssessment.businessControlled,
    };

    if (selectedAssessment.businessControlled) {
      // Submit to business portal
      const result = await BusinessPortalIntegration.submitTestResult(resultData);
      if (result.success) {
        Alert.alert(
          'Results Submitted',
          'Your test results have been submitted to the business for review.',
          [{ text: 'OK' }]
        );
      }
    } else {
      // Handle professional-managed test
      console.log('Professional test result:', resultData);
    }

    // Refresh data
    await loadTestResults();
    await loadAnalytics();
  };

  const renderOverviewTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      {/* Business Connection Status */}
      <View style={styles.connectionCard}>
        <View style={styles.connectionHeader}>
          <View style={styles.connectionStatus}>
            <View style={[styles.statusDot, { backgroundColor: businessConnection.connected ? '#10B981' : '#EF4444' }]} />
            <Text style={styles.connectionTitle}>
              {businessConnection.connected ? 'Connected to Business Portal' : 'Disconnected'}
            </Text>
          </View>
          <TouchableOpacity
            style={styles.syncButton}
            onPress={syncWithBusinessPortal}
            disabled={syncStatus.syncing}
          >
            {syncStatus.syncing ? (
              <ActivityIndicator size={20} color="#3B82F6" />
            ) : (
              <MaterialCommunityIcons name="sync" size={20} color="#3B82F6" />
            )}
          </TouchableOpacity>
        </View>
        {syncStatus.lastSync && (
          <Text style={styles.lastSyncText}>
            Last sync: {new Date(syncStatus.lastSync).toLocaleString()}
          </Text>
        )}
      </View>

      {/* Business Analytics Overview */}
      <View style={styles.analyticsCard}>
        <Text style={styles.cardTitle}>Business Portal Analytics</Text>
        <View style={styles.analyticsGrid}>
          <View style={styles.analyticsItem}>
            <Text style={styles.analyticsValue}>{businessAnalytics.totalTests || 0}</Text>
            <Text style={styles.analyticsLabel}>Available Tests</Text>
          </View>
          <View style={styles.analyticsItem}>
            <Text style={styles.analyticsValue}>{businessAnalytics.totalCandidates || 0}</Text>
            <Text style={styles.analyticsLabel}>Total Candidates</Text>
          </View>
          <View style={styles.analyticsItem}>
            <Text style={styles.analyticsValue}>{businessAnalytics.averageScore || 0}%</Text>
            <Text style={styles.analyticsLabel}>Avg Score</Text>
          </View>
          <View style={styles.analyticsItem}>
            <Text style={styles.analyticsValue}>{businessAnalytics.passRate || 0}%</Text>
            <Text style={styles.analyticsLabel}>Pass Rate</Text>
          </View>
        </View>
      </View>

      {/* Test Categories */}
      <View style={styles.categoriesCard}>
        <Text style={styles.cardTitle}>Test Categories</Text>
        <View style={styles.categoriesContainer}>
          {Object.entries(businessAnalytics.categoryBreakdown || {}).map(([category, percentage]) => (
            <View key={category} style={styles.categoryItem}>
              <View style={styles.categoryInfo}>
                <Text style={styles.categoryName}>{category}</Text>
                <Text style={styles.categoryPercentage}>{percentage}%</Text>
              </View>
              <View style={styles.categoryBar}>
                <View 
                  style={[
                    styles.categoryProgress, 
                    { 
                      width: `${percentage}%`,
                      backgroundColor: getColorForCategory(category)
                    }
                  ]} 
                />
              </View>
            </View>
          ))}
        </View>
      </View>

      {/* Recent Test Results */}
      <View style={styles.resultsCard}>
        <View style={styles.cardHeader}>
          <Text style={styles.cardTitle}>Recent Test Results</Text>
          <TouchableOpacity
            style={styles.viewAllButton}
            onPress={() => setActiveTab('results')}
          >
            <Text style={styles.viewAllText}>View All</Text>
          </TouchableOpacity>
        </View>
        {testResults.slice(0, 3).map((result) => (
          <View key={result.id} style={styles.resultItem}>
            <View style={styles.resultInfo}>
              <Text style={styles.resultTestName}>{result.testName}</Text>
              <Text style={styles.resultCandidate}>{result.candidateName}</Text>
              <Text style={styles.resultDate}>
                {new Date(result.completedAt).toLocaleDateString()}
              </Text>
            </View>
            <View style={styles.resultScore}>
              <Text style={[
                styles.resultScoreText,
                { color: result.passed ? '#10B981' : '#EF4444' }
              ]}>
                {result.score}%
              </Text>
              <View style={[
                styles.resultStatus,
                { backgroundColor: result.passed ? '#10B981' : '#EF4444' }
              ]}>
                <Text style={styles.resultStatusText}>
                  {result.passed ? 'PASSED' : 'FAILED'}
                </Text>
              </View>
            </View>
          </View>
        ))}
      </View>
    </ScrollView>
  );

  const renderTestsTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      {/* Business Tests Section */}
      <View style={styles.testsSection}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>Business Portal Tests</Text>
          <View style={styles.sectionBadge}>
            <Text style={styles.sectionBadgeText}>{businessTests.length}</Text>
          </View>
        </View>
        <Text style={styles.sectionDescription}>
          Tests created and managed by businesses. Access may be restricted.
        </Text>
        
        {businessTests.map((test) => (
          <TouchableOpacity
            key={test.id}
            style={styles.testCard}
            onPress={() => startAssessment(test)}
          >
            <View style={styles.testCardHeader}>
              <View style={styles.testIcon}>
                <MaterialCommunityIcons 
                  name={getIconForCategory(test.category)} 
                  size={24} 
                  color={getColorForCategory(test.category)} 
                />
              </View>
              <View style={styles.testInfo}>
                <Text style={styles.testTitle}>{test.name}</Text>
                <Text style={styles.testDescription}>
                  {test.description || `${test.category} assessment`}
                </Text>
              </View>
              <View style={styles.businessBadge}>
                <MaterialCommunityIcons name="domain" size={12} color="#FFFFFF" />
                <Text style={styles.businessBadgeText}>Business</Text>
              </View>
            </View>
            
            <View style={styles.testMeta}>
              <View style={styles.testMetaItem}>
                <MaterialCommunityIcons name="clock" size={16} color="#6B7280" />
                <Text style={styles.testMetaText}>{test.duration} min</Text>
              </View>
              <View style={styles.testMetaItem}>
                <MaterialCommunityIcons name="help-circle" size={16} color="#6B7280" />
                <Text style={styles.testMetaText}>{test.questions} questions</Text>
              </View>
              <View style={styles.testMetaItem}>
                <MaterialCommunityIcons name="target" size={16} color="#6B7280" />
                <Text style={styles.testMetaText}>{test.passingScore}% pass</Text>
              </View>
              <View style={[styles.difficultyBadge, { backgroundColor: getDifficultyColor(test.difficulty) }]}>
                <Text style={styles.difficultyText}>{test.difficulty}</Text>
              </View>
            </View>

            <View style={styles.testStats}>
              <View style={styles.testStat}>
                <Text style={styles.testStatValue}>{test.assignedCandidates}</Text>
                <Text style={styles.testStatLabel}>Assigned</Text>
              </View>
              <View style={styles.testStat}>
                <Text style={styles.testStatValue}>{test.completedAttempts}</Text>
                <Text style={styles.testStatLabel}>Completed</Text>
              </View>
              <View style={styles.testStat}>
                <Text style={styles.testStatValue}>{test.averageScore.toFixed(1)}%</Text>
                <Text style={styles.testStatLabel}>Avg Score</Text>
              </View>
              <View style={styles.testStat}>
                <Text style={styles.testStatValue}>
                  {test.completedAttempts > 0 ? 
                    Math.round((test.completedAttempts / test.assignedCandidates) * 100) : 0}%
                </Text>
                <Text style={styles.testStatLabel}>Completion</Text>
              </View>
            </View>
          </TouchableOpacity>
        ))}
      </View>

      {/* Professional Tests Section */}
      <View style={styles.testsSection}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>Professional Tests</Text>
          <View style={styles.sectionBadge}>
            <Text style={styles.sectionBadgeText}>{professionalAssessments.length}</Text>
          </View>
        </View>
        <Text style={styles.sectionDescription}>
          Standard assessments available to all professionals.
        </Text>
        
        {professionalAssessments.map((assessment) => (
          <TouchableOpacity
            key={assessment.id}
            style={styles.testCard}
            onPress={() => startAssessment(assessment)}
          >
            <View style={styles.testCardHeader}>
              <View style={styles.testIcon}>
                <MaterialCommunityIcons 
                  name={assessment.icon} 
                  size={24} 
                  color={assessment.color} 
                />
              </View>
              <View style={styles.testInfo}>
                <Text style={styles.testTitle}>{assessment.title}</Text>
                <Text style={styles.testDescription}>{assessment.description}</Text>
              </View>
              <View style={styles.professionalBadge}>
                <MaterialCommunityIcons name="account" size={12} color="#FFFFFF" />
                <Text style={styles.professionalBadgeText}>Professional</Text>
              </View>
            </View>
            
            <View style={styles.testMeta}>
              <View style={styles.testMetaItem}>
                <MaterialCommunityIcons name="clock" size={16} color="#6B7280" />
                <Text style={styles.testMetaText}>{assessment.duration} min</Text>
              </View>
              <View style={styles.testMetaItem}>
                <MaterialCommunityIcons name="help-circle" size={16} color="#6B7280" />
                <Text style={styles.testMetaText}>{assessment.questions} questions</Text>
              </View>
              <View style={styles.testMetaItem}>
                <MaterialCommunityIcons name="target" size={16} color="#6B7280" />
                <Text style={styles.testMetaText}>{assessment.passingScore}% pass</Text>
              </View>
              <View style={[styles.difficultyBadge, { backgroundColor: getDifficultyColor(assessment.difficulty) }]}>
                <Text style={styles.difficultyText}>{assessment.difficulty}</Text>
              </View>
            </View>
          </TouchableOpacity>
        ))}
      </View>
    </ScrollView>
  );

  const renderResultsTab = () => (
    <ScrollView 
      style={styles.tabContent}
      refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} />}
    >
      <View style={styles.resultsHeader}>
        <Text style={styles.resultsTitle}>Test Results</Text>
        <Text style={styles.resultsSubtitle}>
          View all test results from business and professional assessments
        </Text>
      </View>

      {testResults.length === 0 ? (
        <View style={styles.emptyResults}>
          <MaterialCommunityIcons name="clipboard-text" size={64} color="#D1D5DB" />
          <Text style={styles.emptyResultsTitle}>No Results Yet</Text>
          <Text style={styles.emptyResultsText}>
            Complete some assessments to see your results here
          </Text>
        </View>
      ) : (
        testResults.map((result) => (
          <View key={result.id} style={styles.resultCard}>
            <View style={styles.resultCardHeader}>
              <View style={styles.resultTestInfo}>
                <Text style={styles.resultTestTitle}>{result.testName}</Text>
                <Text style={styles.resultTestDate}>
                  Completed on {new Date(result.completedAt).toLocaleDateString()}
                </Text>
              </View>
              <View style={styles.resultScoreContainer}>
                <Text style={[
                  styles.resultScoreValue,
                  { color: result.passed ? '#10B981' : '#EF4444' }
                ]}>
                  {result.score}%
                </Text>
                <View style={[
                  styles.resultPassStatus,
                  { backgroundColor: result.passed ? '#10B981' : '#EF4444' }
                ]}>
                  <Text style={styles.resultPassStatusText}>
                    {result.passed ? 'PASSED' : 'FAILED'}
                  </Text>
                </View>
              </View>
            </View>

            <View style={styles.resultDetails}>
              <View style={styles.resultDetailItem}>
                <MaterialCommunityIcons name="clock" size={16} color="#6B7280" />
                <Text style={styles.resultDetailText}>
                  {Math.floor(result.timeSpent / 60)}m {result.timeSpent % 60}s
                </Text>
              </View>
              <View style={styles.resultDetailItem}>
                <MaterialCommunityIcons name="account" size={16} color="#6B7280" />
                <Text style={styles.resultDetailText}>{result.candidateName}</Text>
              </View>
              <View style={styles.resultDetailItem}>
                <MaterialCommunityIcons name="email" size={16} color="#6B7280" />
                <Text style={styles.resultDetailText}>{result.candidateEmail}</Text>
              </View>
            </View>

            {result.sectionScores && (
              <View style={styles.sectionScores}>
                <Text style={styles.sectionScoresTitle}>Section Breakdown</Text>
                {result.sectionScores.map((section, index) => (
                  <View key={index} style={styles.sectionScoreItem}>
                    <Text style={styles.sectionScoreName}>{section.section}</Text>
                    <Text style={styles.sectionScoreValue}>{section.score}%</Text>
                  </View>
                ))}
              </View>
            )}

            {result.feedback && (
              <View style={styles.resultFeedback}>
                <Text style={styles.resultFeedbackTitle}>Feedback</Text>
                <Text style={styles.resultFeedbackText}>{result.feedback}</Text>
              </View>
            )}

            {result.recommendations && result.recommendations.length > 0 && (
              <View style={styles.resultRecommendations}>
                <Text style={styles.resultRecommendationsTitle}>Recommendations</Text>
                {result.recommendations.map((rec, index) => (
                  <Text key={index} style={styles.resultRecommendationItem}>
                    • {rec}
                  </Text>
                ))}
              </View>
            )}
          </View>
        ))
      )}
    </ScrollView>
  );

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Beginner': return '#10B981';
      case 'Intermediate': return '#F59E0B';
      case 'Advanced': return '#EF4444';
      default: return '#6B7280';
    }
  };

  if (isLoading) {
    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#3B82F6" />
          <Text style={styles.loadingText}>Loading tests and results...</Text>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="dark-content" backgroundColor="#FFFFFF" />
      
      {/* Header */}
      <View style={styles.header}>
        <TouchableOpacity
          style={styles.backButton}
          onPress={() => navigation.goBack()}
        >
          <MaterialCommunityIcons name="arrow-left" size={24} color="#1F2937" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Tests & Interviews</Text>
        <TouchableOpacity
          style={styles.syncButton}
          onPress={syncWithBusinessPortal}
          disabled={syncStatus.syncing}
        >
          {syncStatus.syncing ? (
            <ActivityIndicator size={20} color="#3B82F6" />
          ) : (
            <MaterialCommunityIcons name="sync" size={24} color="#3B82F6" />
          )}
        </TouchableOpacity>
      </View>

      {/* Tabs */}
      <View style={styles.tabsContainer}>
        {[
          { id: 'overview', name: 'Overview', icon: 'view-dashboard' },
          { id: 'tests', name: 'Tests', icon: 'clipboard-text' },
          { id: 'results', name: 'Results', icon: 'chart-line' },
        ].map((tab) => (
          <TouchableOpacity
            key={tab.id}
            style={[styles.tab, activeTab === tab.id && styles.activeTab]}
            onPress={() => setActiveTab(tab.id)}
          >
            <MaterialCommunityIcons
              name={tab.icon}
              size={20}
              color={activeTab === tab.id ? '#3B82F6' : '#6B7280'}
            />
            <Text style={[styles.tabText, activeTab === tab.id && styles.activeTabText]}>
              {tab.name}
            </Text>
          </TouchableOpacity>
        ))}
      </View>

      {/* Tab Content */}
      <View style={styles.content}>
        {activeTab === 'overview' && renderOverviewTab()}
        {activeTab === 'tests' && renderTestsTab()}
        {activeTab === 'results' && renderResultsTab()}
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9FAFB',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#6B7280',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  backButton: {
    padding: 8,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  syncButton: {
    padding: 8,
  },
  tabsContainer: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  tab: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 16,
    paddingHorizontal: 12,
  },
  activeTab: {
    borderBottomWidth: 2,
    borderBottomColor: '#3B82F6',
  },
  tabText: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '500',
    color: '#6B7280',
  },
  activeTabText: {
    color: '#3B82F6',
  },
  content: {
    flex: 1,
  },
  tabContent: {
    flex: 1,
    padding: 20,
  },
  connectionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  connectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  connectionStatus: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    marginRight: 8,
  },
  connectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1F2937',
  },
  lastSyncText: {
    fontSize: 12,
    color: '#6B7280',
  },
  analyticsCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 16,
  },
  analyticsGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  analyticsItem: {
    alignItems: 'center',
  },
  analyticsValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  analyticsLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 4,
  },
  categoriesCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  categoriesContainer: {
    marginTop: 8,
  },
  categoryItem: {
    marginBottom: 12,
  },
  categoryInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  categoryName: {
    fontSize: 14,
    fontWeight: '500',
    color: '#1F2937',
  },
  categoryPercentage: {
    fontSize: 14,
    fontWeight: '600',
    color: '#3B82F6',
  },
  categoryBar: {
    height: 6,
    backgroundColor: '#F3F4F6',
    borderRadius: 3,
  },
  categoryProgress: {
    height: 6,
    borderRadius: 3,
  },
  resultsCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  viewAllButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#EBF4FF',
    borderRadius: 16,
  },
  viewAllText: {
    fontSize: 12,
    color: '#3B82F6',
    fontWeight: '500',
  },
  resultItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F3F4F6',
  },
  resultInfo: {
    flex: 1,
  },
  resultTestName: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
  },
  resultCandidate: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 2,
  },
  resultDate: {
    fontSize: 10,
    color: '#9CA3AF',
    marginTop: 2,
  },
  resultScore: {
    alignItems: 'flex-end',
  },
  resultScoreText: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  resultStatus: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 12,
  },
  resultStatusText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  testsSection: {
    marginBottom: 24,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  sectionBadge: {
    marginLeft: 8,
    paddingHorizontal: 8,
    paddingVertical: 2,
    backgroundColor: '#3B82F6',
    borderRadius: 12,
  },
  sectionBadgeText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  sectionDescription: {
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 16,
  },
  testCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  testCardHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  testIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#F3F4F6',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  testInfo: {
    flex: 1,
  },
  testTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 4,
  },
  testDescription: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20,
  },
  businessBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#3B82F6',
    borderRadius: 12,
  },
  businessBadgeText: {
    marginLeft: 4,
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  professionalBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: '#10B981',
    borderRadius: 12,
  },
  professionalBadgeText: {
    marginLeft: 4,
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  testMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  testMetaItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  testMetaText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
  },
  difficultyBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginLeft: 'auto',
  },
  difficultyText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  testStats: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#F3F4F6',
  },
  testStat: {
    alignItems: 'center',
  },
  testStatValue: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  testStatLabel: {
    fontSize: 10,
    color: '#6B7280',
    marginTop: 2,
  },
  resultsHeader: {
    marginBottom: 20,
  },
  resultsTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 8,
  },
  resultsSubtitle: {
    fontSize: 16,
    color: '#6B7280',
  },
  emptyResults: {
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyResultsTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginTop: 16,
    marginBottom: 8,
  },
  emptyResultsText: {
    fontSize: 14,
    color: '#6B7280',
    textAlign: 'center',
    paddingHorizontal: 40,
  },
  resultCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  resultCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  resultTestInfo: {
    flex: 1,
  },
  resultTestTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 4,
  },
  resultTestDate: {
    fontSize: 12,
    color: '#6B7280',
  },
  resultScoreContainer: {
    alignItems: 'flex-end',
  },
  resultScoreValue: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  resultPassStatus: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  resultPassStatusText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  resultDetails: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 12,
  },
  resultDetailItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
    marginBottom: 4,
  },
  resultDetailText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
  },
  sectionScores: {
    marginBottom: 12,
  },
  sectionScoresTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 8,
  },
  sectionScoreItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 4,
  },
  sectionScoreName: {
    fontSize: 12,
    color: '#6B7280',
  },
  sectionScoreValue: {
    fontSize: 12,
    fontWeight: '600',
    color: '#1F2937',
  },
  resultFeedback: {
    marginBottom: 12,
  },
  resultFeedbackTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 8,
  },
  resultFeedbackText: {
    fontSize: 12,
    color: '#6B7280',
    lineHeight: 18,
  },
  resultRecommendations: {
    marginBottom: 12,
  },
  resultRecommendationsTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 8,
  },
  resultRecommendationItem: {
    fontSize: 12,
    color: '#6B7280',
    lineHeight: 18,
    marginBottom: 2,
  },
});

export default TestsInterviewsScreen;
